"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeSettingsRequestT = exports.ChangeSettingsRequest = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const auto_bone_settings_js_1 = require("../../solarxr-protocol/rpc/auto-bone-settings.js");
const drift_compensation_settings_js_1 = require("../../solarxr-protocol/rpc/drift-compensation-settings.js");
const filtering_settings_js_1 = require("../../solarxr-protocol/rpc/filtering-settings.js");
const hidsettings_js_1 = require("../../solarxr-protocol/rpc/hidsettings.js");
const oscrouter_settings_js_1 = require("../../solarxr-protocol/rpc/oscrouter-settings.js");
const resets_settings_js_1 = require("../../solarxr-protocol/rpc/resets-settings.js");
const stay_aligned_settings_js_1 = require("../../solarxr-protocol/rpc/stay-aligned-settings.js");
const steam_vrtrackers_setting_js_1 = require("../../solarxr-protocol/rpc/steam-vrtrackers-setting.js");
const tap_detection_settings_js_1 = require("../../solarxr-protocol/rpc/tap-detection-settings.js");
const vmcoscsettings_js_1 = require("../../solarxr-protocol/rpc/vmcoscsettings.js");
const vrcoscsettings_js_1 = require("../../solarxr-protocol/rpc/vrcoscsettings.js");
const model_settings_js_1 = require("../../solarxr-protocol/rpc/settings/model-settings.js");
class ChangeSettingsRequest {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsChangeSettingsRequest(bb, obj) {
        return (obj || new ChangeSettingsRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsChangeSettingsRequest(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new ChangeSettingsRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    steamVrTrackers(obj) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? (obj || new steam_vrtrackers_setting_js_1.SteamVRTrackersSetting()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    filtering(obj) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? (obj || new filtering_settings_js_1.FilteringSettings()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    driftCompensation(obj) {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? (obj || new drift_compensation_settings_js_1.DriftCompensationSettings()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    oscRouter(obj) {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? (obj || new oscrouter_settings_js_1.OSCRouterSettings()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    vrcOsc(obj) {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? (obj || new vrcoscsettings_js_1.VRCOSCSettings()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    vmcOsc(obj) {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? (obj || new vmcoscsettings_js_1.VMCOSCSettings()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    modelSettings(obj) {
        const offset = this.bb.__offset(this.bb_pos, 16);
        return offset ? (obj || new model_settings_js_1.ModelSettings()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    tapDetectionSettings(obj) {
        const offset = this.bb.__offset(this.bb_pos, 18);
        return offset ? (obj || new tap_detection_settings_js_1.TapDetectionSettings()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    autoBoneSettings(obj) {
        const offset = this.bb.__offset(this.bb_pos, 20);
        return offset ? (obj || new auto_bone_settings_js_1.AutoBoneSettings()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    resetsSettings(obj) {
        const offset = this.bb.__offset(this.bb_pos, 22);
        return offset ? (obj || new resets_settings_js_1.ResetsSettings()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    stayAligned(obj) {
        const offset = this.bb.__offset(this.bb_pos, 24);
        return offset ? (obj || new stay_aligned_settings_js_1.StayAlignedSettings()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    hidSettings(obj) {
        const offset = this.bb.__offset(this.bb_pos, 26);
        return offset ? (obj || new hidsettings_js_1.HIDSettings()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    static startChangeSettingsRequest(builder) {
        builder.startObject(12);
    }
    static addSteamVrTrackers(builder, steamVrTrackersOffset) {
        builder.addFieldOffset(0, steamVrTrackersOffset, 0);
    }
    static addFiltering(builder, filteringOffset) {
        builder.addFieldOffset(1, filteringOffset, 0);
    }
    static addDriftCompensation(builder, driftCompensationOffset) {
        builder.addFieldOffset(2, driftCompensationOffset, 0);
    }
    static addOscRouter(builder, oscRouterOffset) {
        builder.addFieldOffset(3, oscRouterOffset, 0);
    }
    static addVrcOsc(builder, vrcOscOffset) {
        builder.addFieldOffset(4, vrcOscOffset, 0);
    }
    static addVmcOsc(builder, vmcOscOffset) {
        builder.addFieldOffset(5, vmcOscOffset, 0);
    }
    static addModelSettings(builder, modelSettingsOffset) {
        builder.addFieldOffset(6, modelSettingsOffset, 0);
    }
    static addTapDetectionSettings(builder, tapDetectionSettingsOffset) {
        builder.addFieldOffset(7, tapDetectionSettingsOffset, 0);
    }
    static addAutoBoneSettings(builder, autoBoneSettingsOffset) {
        builder.addFieldOffset(8, autoBoneSettingsOffset, 0);
    }
    static addResetsSettings(builder, resetsSettingsOffset) {
        builder.addFieldOffset(9, resetsSettingsOffset, 0);
    }
    static addStayAligned(builder, stayAlignedOffset) {
        builder.addFieldOffset(10, stayAlignedOffset, 0);
    }
    static addHidSettings(builder, hidSettingsOffset) {
        builder.addFieldOffset(11, hidSettingsOffset, 0);
    }
    static endChangeSettingsRequest(builder) {
        const offset = builder.endObject();
        return offset;
    }
    unpack() {
        return new ChangeSettingsRequestT((this.steamVrTrackers() !== null ? this.steamVrTrackers().unpack() : null), (this.filtering() !== null ? this.filtering().unpack() : null), (this.driftCompensation() !== null ? this.driftCompensation().unpack() : null), (this.oscRouter() !== null ? this.oscRouter().unpack() : null), (this.vrcOsc() !== null ? this.vrcOsc().unpack() : null), (this.vmcOsc() !== null ? this.vmcOsc().unpack() : null), (this.modelSettings() !== null ? this.modelSettings().unpack() : null), (this.tapDetectionSettings() !== null ? this.tapDetectionSettings().unpack() : null), (this.autoBoneSettings() !== null ? this.autoBoneSettings().unpack() : null), (this.resetsSettings() !== null ? this.resetsSettings().unpack() : null), (this.stayAligned() !== null ? this.stayAligned().unpack() : null), (this.hidSettings() !== null ? this.hidSettings().unpack() : null));
    }
    unpackTo(_o) {
        _o.steamVrTrackers = (this.steamVrTrackers() !== null ? this.steamVrTrackers().unpack() : null);
        _o.filtering = (this.filtering() !== null ? this.filtering().unpack() : null);
        _o.driftCompensation = (this.driftCompensation() !== null ? this.driftCompensation().unpack() : null);
        _o.oscRouter = (this.oscRouter() !== null ? this.oscRouter().unpack() : null);
        _o.vrcOsc = (this.vrcOsc() !== null ? this.vrcOsc().unpack() : null);
        _o.vmcOsc = (this.vmcOsc() !== null ? this.vmcOsc().unpack() : null);
        _o.modelSettings = (this.modelSettings() !== null ? this.modelSettings().unpack() : null);
        _o.tapDetectionSettings = (this.tapDetectionSettings() !== null ? this.tapDetectionSettings().unpack() : null);
        _o.autoBoneSettings = (this.autoBoneSettings() !== null ? this.autoBoneSettings().unpack() : null);
        _o.resetsSettings = (this.resetsSettings() !== null ? this.resetsSettings().unpack() : null);
        _o.stayAligned = (this.stayAligned() !== null ? this.stayAligned().unpack() : null);
        _o.hidSettings = (this.hidSettings() !== null ? this.hidSettings().unpack() : null);
    }
}
exports.ChangeSettingsRequest = ChangeSettingsRequest;
class ChangeSettingsRequestT {
    constructor(steamVrTrackers = null, filtering = null, driftCompensation = null, oscRouter = null, vrcOsc = null, vmcOsc = null, modelSettings = null, tapDetectionSettings = null, autoBoneSettings = null, resetsSettings = null, stayAligned = null, hidSettings = null) {
        this.steamVrTrackers = steamVrTrackers;
        this.filtering = filtering;
        this.driftCompensation = driftCompensation;
        this.oscRouter = oscRouter;
        this.vrcOsc = vrcOsc;
        this.vmcOsc = vmcOsc;
        this.modelSettings = modelSettings;
        this.tapDetectionSettings = tapDetectionSettings;
        this.autoBoneSettings = autoBoneSettings;
        this.resetsSettings = resetsSettings;
        this.stayAligned = stayAligned;
        this.hidSettings = hidSettings;
    }
    pack(builder) {
        const steamVrTrackers = (this.steamVrTrackers !== null ? this.steamVrTrackers.pack(builder) : 0);
        const filtering = (this.filtering !== null ? this.filtering.pack(builder) : 0);
        const driftCompensation = (this.driftCompensation !== null ? this.driftCompensation.pack(builder) : 0);
        const oscRouter = (this.oscRouter !== null ? this.oscRouter.pack(builder) : 0);
        const vrcOsc = (this.vrcOsc !== null ? this.vrcOsc.pack(builder) : 0);
        const vmcOsc = (this.vmcOsc !== null ? this.vmcOsc.pack(builder) : 0);
        const modelSettings = (this.modelSettings !== null ? this.modelSettings.pack(builder) : 0);
        const tapDetectionSettings = (this.tapDetectionSettings !== null ? this.tapDetectionSettings.pack(builder) : 0);
        const autoBoneSettings = (this.autoBoneSettings !== null ? this.autoBoneSettings.pack(builder) : 0);
        const resetsSettings = (this.resetsSettings !== null ? this.resetsSettings.pack(builder) : 0);
        const stayAligned = (this.stayAligned !== null ? this.stayAligned.pack(builder) : 0);
        const hidSettings = (this.hidSettings !== null ? this.hidSettings.pack(builder) : 0);
        ChangeSettingsRequest.startChangeSettingsRequest(builder);
        ChangeSettingsRequest.addSteamVrTrackers(builder, steamVrTrackers);
        ChangeSettingsRequest.addFiltering(builder, filtering);
        ChangeSettingsRequest.addDriftCompensation(builder, driftCompensation);
        ChangeSettingsRequest.addOscRouter(builder, oscRouter);
        ChangeSettingsRequest.addVrcOsc(builder, vrcOsc);
        ChangeSettingsRequest.addVmcOsc(builder, vmcOsc);
        ChangeSettingsRequest.addModelSettings(builder, modelSettings);
        ChangeSettingsRequest.addTapDetectionSettings(builder, tapDetectionSettings);
        ChangeSettingsRequest.addAutoBoneSettings(builder, autoBoneSettings);
        ChangeSettingsRequest.addResetsSettings(builder, resetsSettings);
        ChangeSettingsRequest.addStayAligned(builder, stayAligned);
        ChangeSettingsRequest.addHidSettings(builder, hidSettings);
        return ChangeSettingsRequest.endChangeSettingsRequest(builder);
    }
}
exports.ChangeSettingsRequestT = ChangeSettingsRequestT;
